import {registerGlobalInitFunc} from '../modules/observer.ts';

function arrayBufferToBase64(buf: ArrayBuffer): string {
  const bytes = new Uint8Array(buf);
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return btoa(binary);
}

function initSecretFilePicker(input: HTMLInputElement): void {
  const textarea = document.querySelector<HTMLTextAreaElement>('#secret-data');
  const hint = document.querySelector<HTMLElement>('#secret-file-name');
  if (!textarea) return;

  input.addEventListener('change', async () => {
    const file = input.files?.[0];
    if (!file) return;
    const buf = await file.arrayBuffer();
    textarea.value = arrayBufferToBase64(buf);
    textarea.dispatchEvent(new Event('input', {bubbles: true}));
    if (hint) {
      hint.hidden = false;
      hint.textContent = file.name;
    }
  });
}

export function initSecretFilePickerFeature(): void {
  registerGlobalInitFunc('initSecretFilePicker', initSecretFilePicker);
}
